"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.load_more = exports.initialize_load_more = void 0;
/**
 *
 * @param resource
 *  The models name in lower case and plural
 *  e.g : bills
 * @param parameters
 *  Options to restrict the items returned
 * @return {Promise<string>}
 */
var utils_1 = require("../utils/utils");
var seconds_in_a_day = 60 * 60 * 24;
var default_parameters = Object.freeze({
    // select from the responses by queried index
    from: -1,
    take: -1,
    // Pagination
    page: 1,
    per_page: 9,
    // restrict responses to contain the following text
    text_search: "",
    // restrict responses to contain the following title (or identifying string)
    title_search: "",
    // restrict responses to be in this datespan
    date_from: (Math.trunc(Date.now() / 1000)) - 24 * seconds_in_a_day,
    date_to: (Math.trunc(Date.now() / 1000)),
    // Sort "asc" or "desc"
    sort_order: "desc",
    // Any attribute of the model
    sort_by: "created_at",
    // First Letter of Title
    first_letter: "",
    read: true,
});
function initialize_load_more(resource, parameters) {
    parameters = Object.freeze(Object.assign({}, default_parameters, parameters));
    var target = (0, utils_1.get_element_by_id_or_fail)(resource + '-container');
    attach_filter_listener(target, resource, parameters);
    return load_more(resource, parameters, target);
}
exports.initialize_load_more = initialize_load_more;
function load_more(resource, parameters, target) {
    if (!target) {
        throw new Error('Missing Container Element');
    }
    parameters = Object.assign({}, default_parameters, parameters);
    var before_load_more_event = new CustomEvent('lgm.before-load-more', {
        detail: {
            target: target,
            resource: resource,
            parameters: parameters
        }
    });
    // give the possibility to manipulate the request
    window.dispatchEvent(before_load_more_event);
    parameters = Object.freeze(parameters);
    var parameter_bag = [];
    for (var key in parameters) {
        if (!parameters.hasOwnProperty(key))
            continue;
        var value = parameters[key];
        parameter_bag.push(key + "=" + encodeURIComponent(value));
    }
    var query = parameter_bag.join('&');
    // if (window.location.search.includes('iframe=true')) {
    //     query += "&iframe=true";
    // }
    var root = "/" + resource + "/load-more";
    return fetch(root + "?" + query, {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'text/html',
        },
        redirect: 'error'
    })
        .then(function (data) {
        if (!data.ok) {
            throw new Error(data.statusText);
        }
        return data.text();
    })
        .then(function (html) {
        return finish_loading_more(html, target, resource, parameters);
    });
}
exports.load_more = load_more;
function finish_loading_more(html, target, resource, parameters) {
    target.innerHTML = html;
    attach_pagination_listener(target, resource, parameters);
    var finish_load_more_event = new CustomEvent('lgm.finish-load-more', {
        detail: {
            target: target,
            resource: resource,
            parameters: parameters
        }
    });
    if ((target.hasChildNodes()) && ((resource === 'ldt-income') || (resource === 'ldt-reports') || (resource === 'analyte-orders'))) {
        var has_no_data = target.children[0].classList.contains('no-data');
        var index_container_dashboard = target.closest('.py-12');
        if (!!index_container_dashboard) {
            index_container_dashboard.classList.toggle('hide', has_no_data);
        }
    }
    document.dispatchEvent(finish_load_more_event);
    return target;
}
function attach_filter_listener(target, resource, parameters) {
    document.addEventListener('lgm.filter', function (event) {
        if (!(event instanceof CustomEvent))
            return;
        if (!!event.detail.target && event.detail.target === resource)
            return;
        delete event.detail.target;
        var frozen_parameters = Object.freeze(Object.assign({}, parameters, event.detail));
        load_more(resource, frozen_parameters, target)
            .catch(function (e) { return console.error(e); });
    });
}
function attach_pagination_listener(target, resource, parameters) {
    var _a, _b, _c, _d, _e, _f;
    var buttons = target.querySelectorAll('.trigger-load-more-pagination');
    var _loop_1 = function (i) {
        var button = buttons.item(i);
        if (!(button instanceof HTMLElement))
            return "continue";
        var new_params = {};
        if (button.hasAttribute('data-letter-page')) {
            new_params.page = 0;
            new_params.letter_page = button.getAttribute('data-letter-page');
            new_params.first_letter = button.getAttribute('data-letter-page');
        }
        var per_page_attr_name = 'data-per-page-change';
        if (button.hasAttribute(per_page_attr_name)) {
            new_params.per_page = parseInt((_a = parameters.per_page) !== null && _a !== void 0 ? _a : '') +
                parseInt((_b = button.getAttribute(per_page_attr_name)) !== null && _b !== void 0 ? _b : '');
        }
        if (button.hasAttribute('data-page'))
            new_params.page = parseInt((_c = button.getAttribute('data-page')) !== null && _c !== void 0 ? _c : '');
        if (button.hasAttribute('data-per-page'))
            new_params.per_page = parseInt((_d = button.getAttribute('data-per-page')) !== null && _d !== void 0 ? _d : '');
        var to_date_attr_name = 'data-to-date-change';
        if (button.hasAttribute(to_date_attr_name)) {
            new_params.date_to = parameters.date_to
                + seconds_in_a_day * parseInt((_e = button.getAttribute(to_date_attr_name)) !== null && _e !== void 0 ? _e : '');
        }
        var from_date_attr_name = 'data-from-date-change';
        if (button.hasAttribute(from_date_attr_name)) {
            new_params.date_from = parameters.date_from
                + seconds_in_a_day * parseInt((_f = button.getAttribute(from_date_attr_name)) !== null && _f !== void 0 ? _f : '');
        }
        var frozen_parameters = Object.freeze(Object.assign({}, parameters, new_params));
        button.addEventListener('click', function () {
            load_more(resource, frozen_parameters, target)
                .catch(function (e) { return console.error(e); });
        });
    };
    for (var i = 0; i < buttons.length; ++i) {
        _loop_1(i);
    }
}
